import { dateComparator } from '@components/Sorting/Provider';
import { createBestItineraryData } from './createBestItineraryData';

const isOnlyFlight = (transportTypes) => {
  return transportTypes.every((transport) => transport === 'PLANE');
};

const isOneWay = (legs) => {
  return legs.length === 1;
};

const EarliestFlightItineraryBuilder = () => {
  let earliestPosition;
  let earliest = {
    legs: [
      {
        segments: [
          {
            departureDate: '3000-12-31T23:59:59+01:00',
          },
        ],
      },
    ],
  };
  return {
    add(itinerary, position) {
      if (
        isOneWay(itinerary.legs) &&
        isOnlyFlight(itinerary.transportTypes) &&
        dateComparator(itinerary, earliest) < 0
      ) {
        earliest = itinerary;
        earliestPosition = position;
      }
    },
    build() {
      return createBestItineraryData(
        'earliestFlight',
        earliest,
        earliestPosition
      );
    },
  };
};

export default EarliestFlightItineraryBuilder;
